import { getInitialState } from "../../utils";

const initialState = {
  jobs: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_TDS_AND_RIDER_PAYOUT_JOBS_LIST":
      return setTdsAndRiderPayoutJobsList(state, action);
    case "RESET_TDS_AND_RIDER_PAYOUT_JOBS":
      return resetState(state, action);
    default:
      return state;
  }
}

const setTdsAndRiderPayoutJobsList = (state, action) => {
  return {
    jobs: action.payload,
  };
};

const resetState = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};
